import type { CSSProperties } from 'react';

import { Skeleton } from '@radix-ui/themes';
import cn from 'classnames';

export function FileSkeleton({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <li
      className={cn('h-6 flex items-center gap-fly-2', className)}
      style={style}
    >
      <Skeleton className='h-4 w-4' />
      <Skeleton className='h-4 w-[30%]' />
      <Skeleton className='h-4 w-4' />
      <Skeleton className='h-4 w-4' />
      <Skeleton className='h-4 w-4' />
    </li>
  );
}
